export default __webpack_public_path__ + "static/media/view3_year_age_sex.28c90f45.csv";